import { render, staticRenderFns } from "./diagnosis_analysis.vue?vue&type=template&id=040f9c17&scoped=true&"
import script from "./diagnosis_analysis.vue?vue&type=script&lang=js&"
export * from "./diagnosis_analysis.vue?vue&type=script&lang=js&"
import style0 from "./diagnosis_analysis.vue?vue&type=style&index=0&id=040f9c17&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040f9c17",
  null
  
)

export default component.exports